module.exports = __webpack_public_path__ + "media/dad-card-game-detail_optimized.22b16ebe.webm";